const styles = {
  global: {
    body: {
      bg: "bgColor",
    },
  }
}

export default styles;
